// Reserved top level slugs. Mirrors backend app/services/slugs.py and docs/api/reserved_slugs.txt
// (synced from docs/api/reserved_slugs.txt, which also reserves "accessibility" for the G-18 statement page,
// plus "_ui" for the dev gallery route and "appeals" for the G-26 member appeal page /appeals/:id).
// A reserved word, or anything that is not a valid slug, never matches the /:slug community route.

export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  '_fake', '_test', '_ui', 'about', 'accessibility', 'account', 'admin', 'affiliates', 'api', 'app', 'appeals', 'assets', 'billing',
  'brand', 'calendar', 'callback', 'certificates', 'chat', 'checkout', 'classroom', 'course', 'courses',
  'create', 'dashboard', 'discover', 'edit', 'event', 'events', 'explore', 'favicon.ico', 'feed',
  'forgot-password', 'help', 'home', 'inbox', 'invite', 'join', 'leaderboards', 'live', 'login', 'logout',
  'mail', 'manifest.webmanifest', 'map', 'me', 'media', 'members', 'messages', 'mg', 'mgschool', 'new',
  'notifications', 'oauth', 'post', 'posts', 'pricing', 'privacy', 'profile', 'reset-password', 'resources', 'robots.txt',
  'school', 'search', 'settings', 'signup', 'sitemap.xml', 'static', 'support', 'sw.js', 'terms', 'u',
  'unsubscribe', 'uploads', 'verify-email', 'www',
])

/** Characters and length a community slug may have (SCHEMA: 3 to 48 chars of a to z, 0 to 9 and hyphen). */
export const SLUG_PATTERN = /^[a-z0-9-]{3,48}$/

/** True when the word is reserved (case insensitive). */
export function isReservedSlug(slug: string | undefined | null): boolean {
  if (!slug) return false
  return RESERVED_SLUGS.has(slug.toLowerCase())
}

/** True when the path segment could be a community slug (route level guard). */
export function isCommunitySlug(slug: string | undefined | null): boolean {
  if (!slug) return false
  const s = slug.toLowerCase()
  return SLUG_PATTERN.test(s) && !RESERVED_SLUGS.has(s)
}
